import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ContactFab } from './ContactFab';
import './PageShell.css';

export interface PageShellProps {
  children: ReactNode;
}

/**
 * Root visual shell shared by every public route: Header + main content
 * slot + Footer + a floating WhatsApp contact button. The button lives here
 * (not on individual pages) so it appears on every public page, not just Home.
 */
export function PageShell({ children }: PageShellProps) {
  return (
    <div className="dma-page-shell">
      <Header />
      <main className="dma-page-shell__main">{children}</main>
      <Footer />
      <ContactFab />
    </div>
  );
}
